<template>
  <!-- About section start -->
  <section id="about" class="px-12 lg:px-32 py-16 border-t border-stone-500 relative max-width-container">
    <!-- Main text and image container start -->
    <div class="flex flex-col lg:flex-row lg:items-stretch lg:space-x-8">
      <!-- Main text start -->
      <div class="lg:w-1/2">
        <h1 class="uppercase text-3xl mb-4 font-semibold">Rólunk</h1>
        <div class="text-stone-500 mb-8 space-y-4 text-justify">
          <p>
            A <strong>Mozgásban Maradók Egyesülete</strong> szenvedélyesen elkötelezett a
            mozgás, az egészséges életmód és az aktív kikapcsolódás népszerűsítése
            mellett. Célunk, hogy minden korosztály számára maradandó élményeket és
            inspirációt nyújtsunk.
          </p>
          <p>
            Egyedülálló,
            <strong>8 méter magas, háromoldalú mobil mászófalaink</strong> nemcsak izgalmas
            kihívást jelentenek, hanem a <strong>csapatmunka</strong>, a
            <strong>kitartás</strong> és az <strong>önbizalom</strong>
            fejlesztésében is segítenek. Ezek az attrakciók bármilyen rendezvény
            fénypontjai lehetnek.
          </p>
          <p>
            Továbbá, különféle <strong>ügyességi</strong> és
            <strong>fejlesztő játékaink</strong> garantáltan feldobják az eseményeket,
            legyen szó <strong>családi napokról</strong>,
            <strong>céges rendezvényekről</strong> vagy <strong>fesztiválokról</strong>:
          </p>
          <p>
            Óriás jenga, Cornhole, Balance board, Létras célbadobás, Labdás célbadobás –
            szórakoztató és fejlesztő játékok minden korosztálynak.
          </p>
          <p>
            Válasszon minket, és tegye rendezvényét felejthetetlenné egyedi
            programjainkkal és professzionális csapatunkkal!
          </p>
        </div>
      </div>
      <!-- Main text end -->

      <!-- Image container start -->
      <div class="lg:w-1/2">
        <!-- Mobil nézet: <img> -->
        <img v-if="isMobile" :src="aboutImage" alt="Mozgásban Maradók Egyesülete mobil mászófal és ügyességi játékok"
          class="w-full h-auto rounded-lg shadow-lg" />
        <!-- Asztali nézet: background-image -->
        <div v-else class="bg-cover bg-center rounded-lg shadow-lg h-full"
          :style="{ backgroundImage: `url(${aboutImage})` }"></div>
      </div>
      <!-- Image container end -->
    </div>
    <!-- Main text and image container end -->

    <!-- Link with logo start -->
    <div class="flex items-center space-x-4 mt-8 mb-8">
      <a href="https://mozgasbanmaradok.hu" target="_blank" class="flex items-center">
        <img src="@/assets/images/logo/mme_logo.webp" alt="Mozgásban Maradók Egyesülete"
          class="h-16 w-auto max-w-full" />
      </a>
    </div>
    <!-- Link with logo end -->

    <!-- "More" link start -->
    <a href="https://mozgasbanmaradok.hu" target="_blank" class="text-end">
      <p class="font-semibold text-lg group relative">
        <span>mozgasbanmaradok.hu</span>
        <i class="fa-solid fa-arrow-right"></i>
      </p>
    </a>
    <!-- "More" link end -->

    <!-- Circle start -->
    <div class="bg-green-30 h-44 w-44 md:h-52 md:w-52 rounded-full absolute top-0 -left-20 mt-16 -z-20"></div>
    <!-- Circle end -->
  </section>
  <!-- About section end -->
</template>

<script>
export default {
  data() {
    return {
      aboutImage: require("@/assets/images/about/about-image.webp"),
      isMobile: false, // Mobil nézet ellenőrzése
    };
  },
  mounted() {
    this.checkViewport();
    window.addEventListener("resize", this.checkViewport);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkViewport);
  },
  methods: {
    checkViewport() {
      this.isMobile = window.innerWidth < 1024; // Mobil nézet, ha az ablak szélessége kisebb, mint 1024px
    },
  },
};
</script>

<style>
.bg-green-30 {
  background-color: rgba(212, 230, 166, 0.3);
  /* Világos zöld 30% átlátszóság */
}

.bg-cover {
  background-size: cover;
}

.bg-center {
  background-position: center;
}
</style>